export enum ExternalCommunicationValues {
  YES = 'yes',
  NO = 'no',
}
